import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { AuthenticationService } from './shared/services/authentication.service';
import { Router, ActivatedRoute, Event as RouterEvent , NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';

const special_pages  = ['/login', '/join','/'];


@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})

export class AppComponent { 
  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private location: Location
  ) {
     router.events.subscribe((event: RouterEvent) => {
            this.navigationInterceptor(event);
        });
  }
   ngOnInit() {
        const url = this.location.path();
        console.log(url);
        if(!localStorage.getItem("token")){
          this.router.navigate(['login']);
        } else {
          console.log(this.authService.user);
          if(this.authService.user.is_temp_password_set==true){
            this.router.navigate(['reset/password']);
          }else{
            console.log(this.router.url);
            this.router.navigate([url.split(';')[0]]);
          }
          
        }
        /*else if(localStorage.getItem("token")){
          let user  = JSON.parse(localStorage.getItem("user"));
          let getUser =  false;
          if(user){
            getUser = false;
          }else{
            getUser = true;
          }
          this.authenticationService.validateToken(localStorage.getItem("token"), getUser).subscribe((data:any) => {
              console.log(data);
              console.log(user);
              console.log(special_pages.indexOf(url));
              if(getUser)
                  localStorage.setItem('user', JSON.stringify(data));
                  // && special_pages.indexOf(url) != -1
               if(user && user.roles && user.roles.indexOf("admin") != -1 ) {
                    this.router.navigate(['admin/dashboard']);
                } else if(special_pages.indexOf(url) == -1){
                    if(user.label=== ''){
                         this.router.navigate(['basic']);

                    }else{
                         this.router.navigate(['dashboard']);
                    }
                }
          }, (error : any) => {
            console.log(error);
            localStorage.removeItem("token");
            this.authenticationService.loggedIn = false;
            this.router.navigate(['login']);
          })

        }*/
    }
    // Shows and hides the loading spinner during RouterEvent changes
    navigationInterceptor(event: RouterEvent): void {
      if (event instanceof NavigationStart) {
        this.authService.setLoading(true);
      }
      if (event instanceof NavigationEnd) {
        console.log('event end');
        console.log(event);
        this.authService.setLoading(false);
      }

      // Set loading state to false in both of the below events to hide the spinner in case a request fails
      if (event instanceof NavigationCancel) {
        this.authService.setLoading(false);
      }
      if (event instanceof NavigationError) {
        this.authService.setLoading(false);
      }
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/app.component.ts